import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import { BusinessSettingsTitle } from '../../UI';
import QuickbooksForm from './QuickbooksForm';
import styles from './Quickbooks.module.scss';

export interface Props {
    openSidebar?: () => void;
    isMobile?: boolean;
    className?: string;
    onBack?: () => void;
    title: string;
    iconSrc: string;
}

/**
 * Quickbooks component for integrating with QuickBooks and exporting business data
 */
const Quickbooks: FunctionComponent<Props> = ({ openSidebar, isMobile, className, onBack, title, iconSrc }) => {
    const handleBackClick = () => {
        if (onBack) {
            onBack();
        } else if (isMobile && openSidebar) {
            openSidebar();
        }
    };

    return (
        <div className={clsx(styles.container, className)}>
            <div className={styles.titleContainer}>
                <BusinessSettingsTitle className={styles.businessSettingsTitle}>
                    <FontAwesomeIcon
                        icon={faArrowLeft}
                        className={styles.iconBusinessTitle}
                        onClick={handleBackClick}
                    />
                    <img
                        src={iconSrc}
                        alt={title}
                        className={styles.integrationIcon}
                    />
                    {title}
                </BusinessSettingsTitle>
            </div>

            <QuickbooksForm />
        </div>
    );
};

export default Quickbooks;
